// Copyright (c) Docugami, Inc. All rights reserved.

import { emptyGray } from "components/shell/presentation/AppStyles";
import { memo } from "react";
import styled from "styled-components"
import { CardTextStyle, getClassNames } from "./CardStyles";

export const Content = styled.div<{ maxLines?: number }>`
    display: -webkit-box;
    -webkit-line-clamp: ${props => props.maxLines ?? 1};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    ${CardTextStyle};
    &.empty {
        color: ${emptyGray};
        font-style: italic;
        font-weight: 600;
        padding: 0px 3px 0px 0px; // Padding ensures we don't cut off the text since it is italic and inline-flex measurement doesn't account for that
    }
`

export const ContentRoot = styled.div<{ background?: string }>`
    height: fit-content;
    display: inline-flex;
    padding: 2px;
    box-sizing: border-box;
    background: ${props => props.background ?? ''};
`

export type CardTextContentStyles = {
    text?: string | string[];
}

export enum CardTextClassName {
    Empty = 'empty'
}

export interface CardTextContentProps {
    background?: string;
    maxLines?: number;
    text?: string;
    styles?: CardTextContentStyles;
}

export const CardTextContent = memo((props: CardTextContentProps) => {
    return (
        <ContentRoot background={props.background}>
            <Content
                className={getClassNames(props.styles?.text)}
                maxLines={props.maxLines ?? 2}>
                {props.text ?? ''}
            </Content>
        </ContentRoot>
    );
});
